function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isEqual } from 'lodash';
import { ListedDateType, parseListedDateType } from '../../enums/listed-date-type';
import { isShortDate } from '../../utils/is-short-date';
import { SimpleSearchQueryField } from '../simple-search-query-field';
var validateListedDate = listedDate => {
  if (!listedDate || !listedDate.type) {
    return null;
  }
  var upperCaseType = listedDate.type.toUpperCase();
  if (!Object.keys(ListedDateType).includes(upperCaseType)) {
    return null;
  }
  if (upperCaseType === ListedDateType.SPECIFIC_DATE.name) {
    return listedDate.date && isShortDate(listedDate.date) ? {
      type: 'SPECIFIC_DATE',
      date: listedDate.date
    } : null;
  }
  return {
    type: upperCaseType
  };
};
var getDefaultListedDate = searchOptions => {
  if (searchOptions.searchType === 'new-listings' || searchOptions.searchType === 'strict-new-listings') {
    return {
      type: 'TODAY'
    };
  }
  return null;
};
export class ListedDateFilter extends SimpleSearchQueryField {
  constructor(searchOptions, input) {
    var listedDate = validateListedDate(input);
    super(searchOptions, listedDate, getDefaultListedDate(searchOptions));
    _defineProperty(this, "urlSlug", ListedDateFilter.urlSlug);
  }
  isDefault() {
    return isEqual(this.internalValue, this.default);
  }
  getUrlParameterValue() {
    var _this$internalValue;
    if (((_this$internalValue = this.internalValue) === null || _this$internalValue === void 0 ? void 0 : _this$internalValue.type) === 'SPECIFIC_DATE') {
      return this.internalValue.date || null;
    }
    if (!this.internalValue || !this.internalValue.type) {
      return null;
    }
    return this.internalValue.type.toLowerCase();
  }
  static fromUrlParameters(searchOptions, params) {
    var listeddate = params[ListedDateFilter.urlSlug];
    if (!listeddate) {
      return null;
    }
    var type = parseListedDateType(listeddate);
    if (type) {
      return new ListedDateFilter(searchOptions, {
        type
      });
    }
    if (isShortDate("".concat(listeddate))) {
      return new ListedDateFilter(searchOptions, {
        type: 'specific_date',
        date: "".concat(listeddate)
      });
    }
    return null;
  }
}
_defineProperty(ListedDateFilter, "urlSlug", 'listeddate');